module.exports = __webpack_public_path__ + "img/vector-40.4cff217a.svg";